import { Alert, alpha, Box, Card, Divider, Grid, Stack, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import useGiftCreditHistoryRequests from "../hooks/useGiftCreditHistoryRequests"
import NotFound from "./NotFound"
import Loading from "./Loading"

const HistoryRequestsList = () => {
  const { data, isPending } = useGiftCreditHistoryRequests()

  return (
    <Box sx={{ border: 1, borderRadius: "6px", shadow: 1, borderColor: alpha(grey[200], 0.9), p: 2, mt: 5 }}>
      <Alert severity='info'>
        <Typography variant='body1' fontWeight='600'>
          تاریخچه اعتبارهای من
        </Typography>
      </Alert>
      {isPending && <Loading />}
      {!isPending && data?.length === 0 && <NotFound />}
      <Grid container spacing={1} md={12} xs={12} alignItems='center' mt={1}>
        {data?.map((history, index) => (
          <HistoryItem key={index} HistoryRequestListData={history} />
        ))}
      </Grid>
    </Box>
  )
}

const HistoryItem = ({ HistoryRequestListData }) => {
  const { creditLayerName, organizationName, creditAmount, contractNumber } = HistoryRequestListData
  const items = [
    {
      title: "نوع اعتبار",
      value: creditLayerName || ""
    },
    {
      title: "نام سازمان",
      value: organizationName || ""
    },
    {
      title: "مبلغ اعتبار",
      value: creditAmount ? `${Number(creditAmount).toLocaleString()} ریال ` : ""
    },
    {
      title: "شماره قرارداد ",
      value: contractNumber || ""
    }
  ]
  return (
    <>
      <Grid item xs={12}>
        <Box
          sx={{
            border: 1,
            borderRadius: "4px",
            shadow: 2,
            borderColor: grey[200],
            p: 1,
            mb: 1
          }}
        >
          <Card
            sx={{
              display: "flex",
              gap: 1,
              p: 2,
              m: 1
            }}
          >
            <Stack width='100%'>
              <Grid container display='flex' justifyContent='space-between'>
                <Grid item display='flex' alignItems='center' gap={1}>
                  <Typography variant={"h6"}>تاریخ درخواست</Typography>
                  <Typography variant={"subtitle1"}>
                    {new Date(HistoryRequestListData?.createDate).toLocaleString("fa-IR")}
                  </Typography>
                </Grid>

                <Grid item display='flex' alignItems='center' gap={1}>
                  <Typography variant={"h6"}>وضعیت درخواست</Typography>
                  <Typography variant={"subtitle1"}>{HistoryRequestListData?.statusName} </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ mt: 1 }} />
              <Grid container xs={12} sx={{ px: 2, py: 1 }}>
                {items?.map((item, index) => (
                  <Grid item xs={12} md={6} key={index} sx={{ display: "flex", gap: 1 }}>
                    <HistoryGridItem title={item.title} value={item.value} />
                  </Grid>
                ))}
                {HistoryRequestListData?.rejectDescription && (
                  <Grid item xs={12} md={12} sx={{ display: "flex", gap: 1, mt: 2 }}>
                    <Typography variant={"body1"}>علت رد درخواست:</Typography>
                    <Typography variant={"caption"}>{HistoryRequestListData?.rejectDescription}</Typography>
                  </Grid>
                )}
              </Grid>
            </Stack>
          </Card>
        </Box>
      </Grid>
    </>
  )
}

const HistoryGridItem = ({ title, value }) => {
  return (
    <>
      <Typography variant={"body1"}> {title} :</Typography>
      <Typography variant={"caption"}>{value}</Typography>
    </>
  )
}

export default HistoryRequestsList
